var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasModule.news)?_c('div',{attrs:{"data-cy":"NewsBlock"}},[_c('RecentNews'),_c('router-link',{staticClass:"t-body3 u-colorPrimary t-fontWeightMedium t-noLinkAppearance u-aboveCard u-inlineBlock u-marginTop1",attrs:{"to":{
      name: 'news.news',
    },"data-cy":"NewsBlock__openNews"}},[_vm._v(" "+_vm._s(_vm.$t('news.show_all_news'))+" "),_c('SvgIcon',{attrs:{"type":"chevron_right","tiny":""}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }